import React from "react";
import { CloseCircleOutlined } from "@ant-design/icons";
const ErrorPage = () => {
    return (
        <div>
            <div
                style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "80vh",
                }}
            >
                <div style={{ display: "flex", flexDirection: "column" }}>
                    <div className="icons">
                        <CloseCircleOutlined />
                    </div>
                    <h2
                        style={{
                            textAlign: "center",
                            letterSpacing: "2.5px",
                            marginTop: "1rem",
                            color: "grey",
                        }}
                    >
                        Sorry! No such tour exists in our system.
                    </h2>
                </div>
            </div>
        </div>
    );
};

export default ErrorPage;
